/**
 * Route paths, typed for the router.
 *
 * rev v11.0.0 · Phase 2
 *
 * WHY THIS FILE EXISTS
 * --------------------
 * `src/routeTree.gen.ts` declares `FileRouteTypes` but never defines the
 * interface, and the file carries `@ts-nocheck`. The consequence is that
 * the router's `to` type collapses to the default relative paths
 * (`"." | "/" | ".."`), and every `Link` to an absolute path in the
 * application is a type error.
 *
 * That is a repository-wide defect (255 errors in `tsc --noEmit` on
 * `apps/web`, of which the large majority are this one cause). It is
 * recorded in docs/architecture/TECH-DEBT.md with the measurement, and it
 * is NOT fixed here: making the route tree typed requires regenerating it
 * with the TanStack generator, which then demands `search` props on every
 * `Link` — 30 new errors in files that have nothing to do with this
 * programme.
 *
 * Until then, the routes added by this programme go through this helper so
 * that they do not add one more instance of the defect to the count.
 */

/** The absolute paths this programme introduced. */
export const ROUTES = {
  /** The specialty workspace. Takes a `specialty` param. */
  specialty: "/clinical/$specialty",
  /** The rollout dashboard. */
  specialtyAdoption: "/governance/specialty-adoption",
  /** The legacy interface the specialty boundary falls back to. */
  home: "/",
} as const;

/**
 * Cast an absolute path to the router's path type.
 *
 * The cast is safe: the path is a literal that exists in the route tree.
 * The type is only missing because the generated tree does not declare it.
 */
export function asRoutePath(path: string): never {
  return path as never;
}

/** The params of the specialty route. */
export type SpecialtyRouteParams = { specialty: string };
